import { render, staticRenderFns } from "./UrnStorageRequest.vue?vue&type=template&id=6ba2614d&scoped=true&"
import script from "./UrnStorageRequest.vue?vue&type=script&lang=js&"
export * from "./UrnStorageRequest.vue?vue&type=script&lang=js&"
import style0 from "./UrnStorageRequest.vue?vue&type=style&index=0&id=6ba2614d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba2614d",
  null
  
)

export default component.exports